import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { ViewController } from 'ionic-angular/navigation/view-controller';

import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';


/**
 * Generated class for the CarisecPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-carisec',
  templateUrl: 'carisec.html',
})
export class CarisecPage {
  aranan = "";
  skip: number = 0;
  take: number = 50;
  cariListesi = [];
  CariID:string;
 
  

  constructor(public navCtrl: NavController,public bllOrtak:BllOrtak, public navParams: NavParams,public viewCtrl:ViewController,public modalCtrl:ModalController) {
    // this.CariID = navParams.get("cariID");
  }

  ionViewDidLoad() {
    this.cariAra(null);
  }
  cariAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "CariListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.cariListesi = sonuc.SonucObject;
     
    })
  }
  urunler(e) {

    if (e.keyCode == 13) {
      this.cariAra(e);
    }
  }
  CariSec(aktarilacakCariKart) {
    this.viewCtrl.dismiss(aktarilacakCariKart);
 }
}



// WEBPACK FOOTER //
// ./src/pages/faturaislemleri/carisec/carisec.ts